// src/components/Step2Tension.jsx
/**
 * Renders Step 2 (Dialectical Tension) as Thesis, Antithesis, Synthesis (TAS) blocks.
 * No summary or citations are rendered in this view, but a summary block is left occluded (commented) for future use.
 * — DAT-GPT (2025)
 */

import React from "react";
import { renderTAS } from "../utils/referenceUtils.jsx";

export default function Step2Tension({ output }) {
  // Defensive: Always extract as strings, fallback to "N/A"
  const thesis = typeof output?.thesis === "string" ? output.thesis : "N/A";
  const antithesis =
    typeof output?.antithesis === "string" ? output.antithesis : "N/A";
  const synthesis =
    typeof output?.synthesis === "string" ? output.synthesis : "N/A";
  // For future summary rendering (currently unused)
  const summary =
    typeof output?.step2_summary_summary === "string"
      ? output.step2_summary_summary
      : "";

  // Only render if at least one block is not "N/A" or blank
  const hasAnyTAS =
    (thesis && thesis.trim() !== "" && thesis !== "N/A") ||
    (antithesis && antithesis.trim() !== "" && antithesis !== "N/A") ||
    (synthesis && synthesis.trim() !== "" && synthesis !== "N/A");

  if (!hasAnyTAS) return null;

  return (
    <div className="mt-6">
      <h3 className="font-bold mb-2 text-lg text-blue-500">
        Step 2 – Synthesis Feasibility
      </h3>
      <div className="space-y-6">
        {renderTAS(thesis, antithesis, synthesis)}
      </div>
      {/* --- Occluded summary block for future use ---
      {summary && summary.trim() !== "" && summary !== "N/A" && (
        <div className="mt-4 text-sm text-white border-t border-gray-800 pt-2">
          <h4 className="font-semibold text-white mb-1">Summary</h4>
          <div>{summary}</div>
        </div>
      )}
      */}
    </div>
  );
}
